import { SprinklesElement } from "sprinkles-js";

export default class CollapsibleSectionElement extends SprinklesElement {
  static tagName = "collapsible-section";
  static refs = ["trigger", "target", "wrapper"];
  static events = { click: { method: "handleClick", ref: "trigger" } };

  afterConnected() {
    // Ensure we are in a consistent state
    this.#setOpen(this.hasAttribute("data-open"));
  }

  handleClick() {
    const dataOpen = this.toggleAttribute("data-open");
    this.#setOpen(dataOpen);
  }

  #setOpen(open) {
    this.refs.trigger.setAttribute("aria-expanded", open);
    this.refs.target.hidden = !open;
  }
}
